import { styled } from "@mui/material/styles";
import type { AppBarProps } from "@mui/material/AppBar";
import MuiAppBar from "@mui/material/AppBar";

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
}));

export const Logo = styled("figure")`
    height: 40px;
    position: relative;
    margin: 0;
    margin-left: -5px;

    img {
        display: block;
        position: relative;
        height: 100%;
    }
`;
